export * from './nr.component';



// WEBPACK FOOTER //
// /ng-app/src/shared/no-records.component/index.ts